import React from 'react'
import { Box, Chip, Typography } from '@mui/material'
import CustomTooltip from '../../../CustomTooltip'
import { ToolTipWrapper } from '../ObjectList/styles'
import { grey } from '../../../../colors'

export interface DataItem {
  title: string
  value: string
}

interface ChipsDisplayProps {
  data: DataItem[]
}

// It shows the first two chips by default and truncates the rest, displaying them inside a tooltip.
// Each chip can show additional information when hovered over.

const ChipsForAttributes: React.FC<ChipsDisplayProps> = ({ data }) => {
  // Limit the number of chips to display (2 chips initially)
  const visibleChips = data.slice(0, 2)
  const remainingChips = data.slice(2)

  const renderChips = (chips: DataItem[], subTooltips = false): JSX.Element[] => {
    return chips.map((chip: DataItem, index: number) => (
      <Box key={index}>
        <CustomTooltip title={<Typography>{chip.title}</Typography>}>
          <Chip size="small" label={chip.value} variant="outlined" color="primary" sx={{ background: subTooltips ? grey[25] : 'unset' }} />
        </CustomTooltip>
      </Box>
    ))
  }

  const Title = (): JSX.Element => (
    <Box display="flex" gap={1} flexWrap="wrap">
      {renderChips(remainingChips, true)}
    </Box>
  )

  return (
    <Box display="flex" justifyContent="center" alignItems="center" gap={1}>
      {/* Render the visible chips (first 2 chips) */}
      {renderChips(visibleChips)}

      {remainingChips.length > 0 && (
        <ToolTipWrapper>
          <CustomTooltip title={<Title />}>
            <Typography>...</Typography>
          </CustomTooltip>
        </ToolTipWrapper>
      )}
    </Box>
  )
}

export default ChipsForAttributes
